<template>
    <v-flex xs12  >
        <!--<v-card color="primary" @click="menu_click">-->
        <!--<img class="offset-img" style="object-fit: cover;" src="data:image/png;base64,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"  />-->
        <!--</v-card>-->
        <v-list  class="div-left"  fill-height>
            <!--list-group class no-action 預設 padding-left:27px -->
            <v-flex v-for="(item, index) in funList" :key="index">

                <!-- value="true" 可預設展開全部的 menu-->
                <v-list-group
                        v-model="item.active"
                        v-if="item.innerMenu!==undefined&&item.innerMenu.length>0"
                        class="div-left"
                >
                    <!-- one level-->
                    <v-list-item class="itemStyle"  slot="activator"  @click="changeTitleColor(index)">
                        <v-list-item-action style="height: 40px" >
                            <img :src="item.funIcon!=''?item.funIcon:defaultGrayFolder" class="img40">

                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title :class="[ item.funId==parentId ? 'vListTileActive' : 'vListTile']">  {{ item.funTitle }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <!-- :class="[ subItem.funUrl.toLowerCase()==$route.path.replace('/home/','') ? 'vSbuTileActive' : '']"
                    :class="[$route.path.replace('/home/','').indexOf( subItem.funUrl.toLowerCase())>-1 ? 'vSbuTileActive' : '']"
                    -->
                    <!--subItem.funParam!=''&&subItem.funUrl=='FloorplanCreate'&&$route.path.indexOf(JSON.parse(subItem.funParam).markinfoSystem)>-1?'vSbuTileActive':'',-->
                    <v-list-item v-for="(subItem,key) in item.innerMenu" :key="subItem.funTitle"
                                 style="cursor: pointer;"
                                 @click="asideListClick(key,subItem.funUrl,subItem.funParam,subItem.parentId,subItem.funTitle,subItem.securityType)"
                                 active-class="vSbuTileActive"

                                 class="pl-7">
                        <v-list-item-action >
                            <img :src="subItem.funIcon!=''?subItem.funIcon:defaultGrayIcon" class="img25">
                        </v-list-item-action>
                        <v-list-item-content>

                            <v-list-item-title
                                    :class="[$route.path.replace('/home/','')==( '/'+subItem.funUrl.toLowerCase())&&subItem.funParam==''||subItem.funParam==undefined ? 'vSbuTileActive' : '',
                       $route.path.replace('/home/','')==''&&item.funUrl=='AppArticle'?'vSbuTileActive':'',
                       subItem.funParam!=''&&subItem.funTitle==funTitle&&$route.query.zone==JSON.parse(subItem.funParam).zone?'vSbuTileActive':'',
                       subItem.funParam!=''&&$route.path.indexOf(JSON.parse(subItem.funParam).divCode)>-1&&($route.path).split('/')[($route.path).split('/').length - 1]==JSON.parse(subItem.funParam).divCode?'vSbuTileActive':'',]">
                                {{ subItem.funTitle }}
                                <!--{{subItem.funParam!=''&&$(JSON.parse(subItem.funParam).divCode)==undefined&&$route.path.replace('/home/','')==( '/'+subItem.funUrl.toLowerCase())+'?zone='+$route.query.zone?'vSbuTileActive':''}}-->

                            </v-list-item-title>


                        </v-list-item-content>

                    </v-list-item>

                </v-list-group>

                <v-list-item v-else
                             style="cursor: pointer"
                             @click="asideListClick(index,item.funUrl,item.funParam,item.parentId,item.funTitle,item.securityType)"
                             active-class="vSbuTileActive"
                             class="">
                    <v-list-item-action :class="[item.funIcon==''?'img25':'img25']">
                        <img :src="item.funIcon!=''?item.funIcon:defaultGrayIcon" class="img25">
                    </v-list-item-action>
                    <v-list-item-content>

                        <v-list-item-title
                                :class="[$route.path.replace('/home/','')==( '/'+item.funUrl.toLowerCase())&&item.funParam==''||item.funParam==undefined ? 'vSbuTileActive' : '',
                     $route.path.replace('/home/','')==''&&item.funUrl=='AppArticle'?'vSbuTileActive':'',
                     item.funParam!=''&&item.funTitle==funTitle&&$route.query.zone==JSON.parse(item.funParam).zone?'vSbuTileActive':'',
                     item.funParam!=''&&$route.path.indexOf(JSON.parse(item.funParam).divCode)>-1&&($route.path).split('/')[($route.path).split('/').length - 1]==JSON.parse(item.funParam).divCode?'vSbuTileActive':'',]">
                            {{ item.funTitle }}
                        </v-list-item-title>


                    </v-list-item-content>
                </v-list-item>


            </v-flex>



            <v-progress-circular
                    rounded
                    height="6"
                    v-show="loadMenu"
                    :size="50"
                    color="primary"
                    :indeterminate="loadMenu"
            >載入中...</v-progress-circular>
        </v-list>

    </v-flex>
</template>

<script>
    import {EventBus} from '../../js/event-bus'
    export default {
        name: "AppAside",
        data() {
            return {
                funTitle:'',
                count:0,
                effFlagModel:'',
                loadMenu:false,
                funList:[],
                selectIndex:-1,
                parentId:'',
                defaultGrayIcon:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAw5JREFUeNrsnb1u2lAYhg8WDCDVQyPVkRqprlQWpHpoBiI1QzKGKb2CcEnNHaRXUJbQEQaGMKQDAwxUipFACpVgoFI92BL159oVJtjEh2Owy/tIFkqCYvL4PX+Rv+PMfD5nQdTr3y7tFzrO7OMN2y8G9tG0j1qlclELelNmlUBbHAm72UNpYTKrtsjm8g+kFfI+2y8NyPNBLhqum+AE2m+g1F3BVyhf7CRWnyTQtQt567laTKKTQLfPa8BNJM6pT/QSeAMfkXGcZW5v6zRN+QofXHyS3Hke4ONScifJgI8zCfO9zeaHEhxsRnZXJz44eMk0TWP5fD72cxmGwYbDEdN1nZmmKfR37ySBR0evWblc3oo8gs5TLL5jp6cfmSzL6RZI8ih5u4BEnpyIvXDZpMjr93/EJu3wUGHZ7N8/lV6LxSLrdDrpErguef1+P7Zz67rsJM+TSJ+Fzkd9YyqaMF3xXTVbYjabsW63+2QQS0UCSRxd8V0zHv9catqF5A8iSZFHiJ6+xC4wSfLiREqCPMuyIHCT5E0mEyzlcrmcs7qQ5RccHfwYCdS091zyptOps07da4E021cUhWN+9ovd339P9SAipAkXCtHXlpS6Xq8X2/QidX3gspygZZJlmezxcSxkGfXfChyNhvbIOmX7AP4jDYEQCIEQCCAQAiEQAgEEQiAEQiCAQAiEQAgEEAiBEAiBAAIhEAIhEEAgBEIgBAIIhEAIhMDUQlUEiRVomv5CGZ4bzuNGUV75vjaM38kRSNWQi9VGqqomSiJVqZdKJd/3RN2CLOwe6YcH3Smr9zg+/hB6s/m2WC64JkR+LmECqYCZUrdYbJPEYkNqKSKLu4UOIu122ymeSSqUuru7ttBWIbTMgYpmWq2WkzxVfctV+hWXuLi2PYmt0CbN9W+YB25Z4AAauBmQwCY8cOPsYFmDB25q3h6qOsM2eJGbb6VyoXqDSBU+IlP9Nwq7O3Rfw8mzufZ2NcdG3NFZvRG3m8Qqkrg2eb7uDg8jeOaAwQIeRpDB4zBCpZGw0Mdh/BFgAJsmF+veHnuZAAAAAElFTkSuQmCC',
                defaultGrayFolder:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAexJREFUeNrs3L9KQlEcwPGjFkiL5ipkDdVi6WyDvkG+Qc25iA2tPUCZS836Bj5AQ3/ISVDcqqEhjFxMG66amP0OOFh0g7w3wuv3CwfhIlf83D+eI6hrOBwqmjw3BAACCCCABCCAAAJIv2/u64b9TGZZHtIyohb3nZdRPM5mW04GdI0v5UZ4VRk+m/bflpEQxOqsXMK7NuKp0b4uRgeGe6AFxKIg+gGcvIhGBNBacTkL8wBaa0cQ0wBa60QQdwG0Vk4QowBan95MPeLcP762RqwI4rRY6UXBoSwKcqyFJz/g+v6dANBaiYkv4UAgoBZlOLWXZlM1ZfzJPTAYDKq9VEp5vV7HAna7XXV2eqrq9br9n8LhcNjReDr9/raTyamYxrASoW/ugUuhUMLn//5bp6fnZ5UvFGYCZSMSMZ8MtlpMY7iEAQSQAAQQQAAJQAABBBBAAhBAAAEkAAEEEEACEEAAASQAAQQQQAIQQAABJAABBHA2AA3DmIfk5956vZAp4Gu7Xev3+yiZpG0ajcb5+LZPP3MoXV/lOh0jtrq2vun2eBAb630wUPd3t7VKuXxkCig9yhMOZHApm5yE2mh8g+vrn9DGt2IL8rCi7P0DHiekf3D9cHlTMn4EJKYxAAIIIAEIIIAAEoB/3ocAAwCMSXxGNs1ViwAAAABJRU5ErkJggg==',
            }
        },
        created(){ //畫面一建立 就抓取左邊選單的資料
            this.axios_getFunList();
        },
        computed:{
            loginUser(){
                return this.$store.state.loginUser;
            },
        },
        mounted(){
            this.openMaintain();
        },
        watch:{
            count(val){
                if(val==10){
                    this.axios_getMaintainModel(this.effFlagModel);
                }
            },
            effFlagModel(val){
                console.log(val)
            },
            // '$route.query.zone': function () { //110/09/14 偵測如果zone改變 menu 資料要重抓 by IvyLin
            //    if(this.count!==10){
            //       this.axios_getFunList();
            //    }
            // },
        },
        methods:{
            splitURL(name,url){
                return  decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(this.$store.state.AppSetting.backSrvUrl+"?"+url)||[""])[1].replace(/\+/g,'%20'))||null;
            },
            openMaintain(){  //search-filter
                let self = this;
                EventBus.$on('open-maintain', function(val,model) {
                    self.count = val;
                    self.effFlagModel = model;
                    return val;
                });
            },
            menu_click: function () {
                this.$emit('menu_click', "");
            },
            axios_getFunList(){
                this.funList = [];
                this.loadMenu = true;
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                // let url = this.$store.state.AppSetting.backSrvUrl + "funlist/noauth";
                let url = this.$store.state.AppSetting.backSrvUrl + "funlist/datasearch/masterdetail/"+zone+"/NORMAL";
                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.funList = response.data.resultSet;
                        this.loadMenu = false;
                    }else{
                        this.funList = [];
                        this.loadMenu = false;
                    }
                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.funList = [];
                        this.loadMenu = false;
                    } catch(err) {
                        this.funList = [];
                        this.loadMenu = false;
                    }
                });

            },
            asideListClick(index,name,params,parentId,funTitle,securityType){//加入zoneList 判斷 110/09/14 by IvyLin
                // this.fillAsideColor(params,name);
                this.funTitle = funTitle;
                this.parentId =parentId;

                if(params==""){
                        this.$router.push({ name: name}).catch(() => {
                        })


                }else{
                    let parseParamsClinic = JSON.parse(params);
                    let nameList = ['ClinicA','ClinicB','ClinicC','ClinicD'];
                    let isQueryType = parseParamsClinic.hasOwnProperty('querytype');
                 if(nameList.includes(name)&&isQueryType){
                        if(parseParamsClinic.querytype=='doctor'){
                            delete parseParamsClinic.querytype;
                            this.$router.push({name:name, query:parseParamsClinic})
                        }
                 }else {
                     let parseParams = JSON.parse((params));
                     let isZone = (parseParams.hasOwnProperty('zone'))
                     if(isZone){
                         this.$router.push({name:name, params:parseParams,query:{zone:parseParams.zone}})
                     }else {
                         this.$router.push({name:name, params:parseParams}).catch(() => {
                         })
                     }
                 }



                }
                let secJson = '';
                if(typeof securityType == "string"&&securityType.indexOf('{')>-1){
                    secJson = securityType==''?'': JSON.parse(securityType)
                }else if(typeof securityType == "object"){
                    secJson = securityType
                }else {
                    secJson == '';
                }
                let secTypeStr = '';
                if(secJson !== ''){
                    for(let i in secJson ){
                        secTypeStr +=secJson[i].CODE
                    }
                }
                let menuInfo ={
                    funTitle: funTitle,
                    funUrl: name,
                    parentId: parentId,
                    // securityType: secJson!=''?secJson[0].CODE:'',
                    securityType: secJson!=''?secTypeStr:'',
                };
                this.$store.commit('setMenuInfo', menuInfo);

            },
            changeTitleColor(index){
                this.selectIndex = index;
            },
            fillAsideColor(funParam,funURL){
                console.log(funURL);
                if(funParam!==''&&funParam!==undefined){
                    let json = JSON.parse(funParam);
                    return json.formKind
                }
            },
            axios_getMaintainModel(effFlagModel){ //取得維護模式清單 使用者維護模式 effFlag = Y U
                console.log(effFlagModel)
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                this.funList = [];
                this.loadMenu = true;
                // let url = this.$store.state.AppSetting.backSrvUrl + "funlist/maintainmode";
                let model = '';
                if(effFlagModel=='U'){
                    model = 'USER'
                }else if(effFlagModel=='M'){
                    model = 'ADMIN'
                }
                let url = this.$store.state.AppSetting.backSrvUrl + "funlist/datasearch/masterdetail/"+zone+"/"+model;
                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.funList = response.data.resultSet;
                        this.loadMenu = false;
                    }else{
                        this.funList = [];
                        this.loadMenu = false;
                    }
                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.funList = [];
                        this.loadMenu = false;
                    } catch(err) {
                        this.funList = [];
                        this.loadMenu = false;
                    }
                });

            },


        }
    }
</script>

<style scoped>



    .img25{
        float: right;
        width: 25px;
        height: 25px;
    }

    .noImg25{
        float: right;
        width: 0px;
        height: 0px;
    }

    .img40{
        float: right;
        width: 40px;
        height: 40px;
    }
    .v-list-item .itemStyle{
        padding: 0px 0px!important;
        margin-right: -30px!important;
        margin-left: -10px!important;
    }

    .v-list-group__items {
        -webkit-box-flex: 1;
        -ms-flex: 1 1 auto;
        flex: 1 1 auto;
        margin: 0px 15px;
    }

    .v-list-item__action {
        -ms-flex-item-align: center;
        align-self: center;
        margin: 0px 5px;
    }

    .v-list-item__action, .v-list-item__avatar, .v-list-item__icon {
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        min-width: 24px;
        margin: 0px 5px 5px 5px;
    }



    .v-list-item__title, .v-list-item__subtitle {
        white-space: normal!important;
        overflow: unset!important;
        text-overflow: ellipsis;
        -webkit-transition: .3s cubic-bezier(.25,.8,.5,1);
        transition: .3s cubic-bezier(.25,.8,.5,1);
        width: 100%;
        height: auto!important;
        /*margin-right: 10px;*/
    }

    .v-list-item__content {
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-item-align: center;
        align-self: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        -webkit-box-flex: 1;
        -ms-flex: 1 1;
        flex: 1 1;
        overflow: hidden;
        padding: 0px 0;
        margin-right: 5px;
    }

    .v-list--two-line .v-list__tile {
        height: auto!important;
    }

    .v-list--three-line .v-list__tile {
        height: auto!important;
    }




    .offset-img {
        position: relative;

    }

    .vListTile{
        color: black;
        width: 115px!important;
        text-align: left;
        /*background: #fff;*/
    }


    .vListTileActive{
        /*background: #B98AF8!important;*/
        color: #D13F72;
        font-weight: bold;
        /*padding:-2px;*/
        /*margin:1px;*/
    }

    .vSbuTileActive{
        /*background: #B98AF8!important;*/
        color: #D13F72;
        /*font-weight: bold;*/
        padding:-2px;
        /*margin:1px;*/
    }

    .listGroup >.v-list-item {
        min-height: 35px;
        padding: 0 5px;

    }

</style>